import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../Redux/Hooks";
import { getWhatsAppAccounts, getWalletBalance } from "../Redux/ApiCalls/Dashboard/WhatsAppAPI";

/**
 * Hook for WhatsApp main dashboard: account status, wallet balance, loading.
 * Fetches account + wallet balance on mount (matching app's WhatsAppCRMScreen).
 */
export function useWhatsApp() {
  const dispatch = useAppDispatch();
  const {
    whatsAppAccount,
    accountLoading,
    walletBalance,
    walletLoading,
    error,
    isError,
  } = useAppSelector((state) => state.whatsapp);

  const refresh = useCallback(() => {
    dispatch(getWhatsAppAccounts()).then((result) => {
      // After account loads, fetch wallet balance (matching app flow)
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(getWalletBalance());
      }
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getWhatsAppAccounts()).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(getWalletBalance());
      }
    });
  }, [dispatch]);

  return {
    whatsAppAccount,
    walletBalance,
    loading: accountLoading || walletLoading,
    accountLoading,
    walletLoading,
    error,
    isError,
    refresh,
  };
}
